import { ReactElement } from "react";
import { Icon, IconProps } from "./Icon";
import { get } from "lodash";
import { iconMap } from "./iconMapping";

export function isIconName(name: unknown): name is IconProps["name"] {
  return typeof name === "string" && name in iconMap;
}

export function isIconProps(props: unknown): props is IconProps {
  return isIconName(get(props, "name"));
}

export function renderIcon(icon: ReactElement | IconProps | IconProps["name"]) {
  if (isIconName(icon)) {
    return <Icon name={icon} />;
  } else if (isIconProps(icon)) {
    return <Icon {...icon} />;
  } else {
    return icon;
  }
}
